import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { routeTree } from './routeTree.gen';
import './styles/globals.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 60_000,
    },
  },
});

const router = createRouter({
  routeTree,
  // Pre-launch: приложение живёт под /job/. Голая / редиректит на /job/
  // на уровне edge (functions/_middleware.ts). Vite base остаётся '/' —
  // ассеты лежат в dist/assets/ и отдаются из корня; basepath решает
  // только клиентскую маршрутизацию (<Link>/navigate basepath-aware).
  basepath: '/job',
  context: { queryClient },
  defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
